import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ChangeEvent, PureComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action, Dispatch } from 'redux';
import messages from '../../../../intl/messages';
import {
  AirSegmentDetails,
  SegmentTypes,
} from '../../../../models/itinerary';
import { AppState } from '../../../../store/model';
import {
  findSegment,
  getSegmentType,
  getTravellerCount,
  isSaviSelectIntl,
} from '../../../../store/reducers/itinerary/selectors';
import { findSegment as findSegmentDetails } from '../../../../store/reducers/segment-details/selectors';
import { getSegmentOption } from '../../../../store/reducers/segment-options/selectors';
import { selectOption } from '../../../../store/reducers/selected-options/actions';
import { isSelected } from '../../../../store/reducers/selected-options/selectors';
import { formatTravelTime } from '../../../../utils/format';
import { spacings } from '../../../lab/spacings';
import { DurationColumn } from './Columns/DurationColumn';
import { ProviderColumn } from './Columns/ProviderColumn/ProviderColumn';
import { SelectColumn } from './Columns/SelectColumn';
import { Header } from './Header/Header';
import { RateDetails } from './Rates/RateDetails';
import { RateSummary } from './Rates/RateSummary';
import { RouteType as Route } from './Route/Types/RouteType';
import { Section } from './Section';
import {
  getACarDetailsForSaviSelectIntl,
  getAHotelDetailsForSaviSelectIntl,
  getSegmentTypeForSaviSelectIntl,
  getSelectedCarSegmentCombinationForSaviSelectIntl,
  getSelectedHotelSegmentCombinationForSaviSelectIntl
} from '../../../../store/reducers/itinerary/saviSelectIntlSelector';
import { ProviderNameText } from '../../../lab/TextStyles/ProviderNameText';
import { setRecommendedCarItem, setRecommendedHotelItem } from '../../../../store/reducers/itinerary/actions';

interface OwnProps {
  index: number;
  optionId: string;
  segmentId: number;
  isRecommended: boolean;
  onFareToggle?: () => void;
}

interface StateProps {
  days?: number;
  nights?: number;
  orderId: number;
  selected: boolean;
  totalDuration?: string;
  travellerCount: number;
  type: SegmentTypes;
  isSaviSelectIntl: boolean;
  providerName?: string;
}

interface DispatchProps {
  onOptionSelect(isSaviSelectIntl: boolean, type: string): void;
}

interface State {
  isFareExpanded: boolean;
}

interface OptionDesktopProps
  extends OwnProps,
    StateProps,
    DispatchProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

class OptionDesktopBase extends PureComponent<OptionDesktopProps, State> {
  constructor(props: OptionDesktopProps) {
    super(props);
    this.state = {
      isFareExpanded: false,
    };
  }

  public render() {
    const {
      classes,
      isRecommended: recommended,
      index,
      selected,
      orderId,
      optionId,
      type,
      onOptionSelect,
      isSaviSelectIntl,
      providerName
    } = this.props;

    const { isFareExpanded } = this.state;

    return (
      <div className={!isSaviSelectIntl ? classes.container : classes.containerForSaviSelectIntl}>
        <Paper className={classes.panel} elevation={1}>
          <Header recommended={recommended} type={type} index={index} />
          <Divider />
          {isSaviSelectIntl && type == 'Hotel' && providerName &&
            <Grid item style={{paddingLeft: "15px", paddingTop: "10px", fontSize: "16", marginBottom: "-10px"}}>
              <ProviderNameText>{providerName}</ProviderNameText>
            </Grid>
          }
          <Section
            container
            wrap="nowrap"
            direction="row"
            alignItems="center"
            spacing={16}
          >
            <Grid container item zeroMinWidth xs={4} alignItems="center">
              <ProviderColumn optionId={optionId} segmentId={orderId} />
            </Grid>
            <Grid container item zeroMinWidth xs={6} spacing={16}>
              <Grid item xs={9} zeroMinWidth>
                <Route optionId={optionId} segmentId={orderId} />
              </Grid>
              <Grid item xs={3} zeroMinWidth
                style={
                  (isSaviSelectIntl && type == 'Car') ?
                  { paddingLeft: 29, paddingTop: 30 } :
                  (isSaviSelectIntl && type == 'Hotel') ?
                  {paddingLeft: 29, } : {}
                }>
                <DurationColumn duration={this.getDuration()}/>
              </Grid>
            </Grid>
            <Grid container item zeroMinWidth xs={2} alignItems="center">
              <SelectColumn selected={selected} onSelect={() => onOptionSelect(isSaviSelectIntl, type)} />
            </Grid>
          </Section>
        </Paper>
        <ExpansionPanel onChange={this.onExpansionPanelChange}>
          <ExpansionPanelSummary
            className={classes.expansionPanel}
            expandIcon={<ExpandMoreIcon />}
            classes={{ content: classes.expansionPanelContent }}
          >
            <RateSummary
              type={type}
              expanded={isFareExpanded}
              segmentId={orderId}
              optionId={optionId}
            />
          </ExpansionPanelSummary>
           <ExpansionPanelDetails>
              <RateDetails optionId={optionId} segmentId={orderId} type={type} />
            </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }

  private onExpansionPanelChange = (
    _event: ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    this.setState({ isFareExpanded: expanded });
  };

  private getDuration = (): string => {
    const { type } = this.props;
    switch (type) {
      case 'Air':
        return this.getAirDuration();
      case 'Hotel':
        return this.getHotelDuration();
      case 'Car':
        return this.getCarDuration();
    }
  };

  private getAirDuration = (): string => {
    const { totalDuration } = this.props;

    return formatTravelTime(totalDuration as string);
  };

  private getHotelDuration = (): string => {
    const {
      intl: { formatMessage },
      nights,
    } = this.props;

    return formatMessage(messages.hotel.nights, {
      numberOfNights: nights,
    });
  };

  private getCarDuration = (): string => {
    const {
      intl: { formatMessage },
      days,
    } = this.props;

    return formatMessage(messages.car.days, { days });
  };
}

const mapStateToProps = (
  state: AppState,
  { segmentId, optionId }: OwnProps,
): StateProps => {
  if(!isSaviSelectIntl(state)) {
    const type = getSegmentType(segmentId)(state) || 'Air';
    const { days, nights } = findSegmentDetails(segmentId)(state);

    const { totalDuration } = getSegmentOption(segmentId, optionId)(
      state,
    ) as AirSegmentDetails;

    const segment = findSegment(segmentId)(state);

    return {
      type,
      orderId: segment ? segment.orderId : 0,
      days,
      nights,
      totalDuration,
      travellerCount: getTravellerCount(state),
      selected: isSelected(segmentId, optionId)(state),
      isSaviSelectIntl: false,
    };
  } else {
    const type = getSegmentTypeForSaviSelectIntl(segmentId)(state);
    let nights = 1;
    let days = 1;
    let providerName = "";
    let selected = false
    if(type == "Hotel") {
      const hotel = getAHotelDetailsForSaviSelectIntl(segmentId, Number(optionId))(state);
      nights = hotel!.duration;
      providerName = hotel!.hotelName;
      selected = getSelectedHotelSegmentCombinationForSaviSelectIntl(segmentId)(state)!.landId == Number(optionId);
    }
    if(type == "Car") {
      const car = getACarDetailsForSaviSelectIntl(segmentId, Number(optionId))(state);
      days = car!.duration;
      selected = getSelectedCarSegmentCombinationForSaviSelectIntl(segmentId)(state)!.landId == Number(optionId);
    }
    return {
      type,
      orderId: segmentId,
      days,
      nights,
      totalDuration: "",
      travellerCount: getTravellerCount(state),
      selected: selected,
      isSaviSelectIntl: true,
      providerName: providerName
    }
  }
};

const mapDispatchToProps = (
  dispatch: Dispatch<Action>,
  { segmentId, optionId }: OwnProps,
): DispatchProps => ({
  onOptionSelect: (isSaviSelectIntl: boolean, type: string) => {
    if(!isSaviSelectIntl) {
      dispatch(selectOption(segmentId, optionId, false));
    } else {
      if(type === "Hotel") {
        dispatch(setRecommendedHotelItem({id: -1, landId: Number(optionId), type0Id: segmentId}));
      } else {
        dispatch(setRecommendedCarItem({id: -1, landId: Number(optionId), type0Id: segmentId}));
      }
    }
  },
});

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { card: cardSpacing },
    },
  } = spacings(theme);

  return createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
      '&:not(:first-child)': cardSpacing,
    },
    containerForSaviSelectIntl: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
      '&:not(:first-child)': cardSpacing,
      border: `2px solid ${theme.zeno.main.primary.main}`,
    },
    panel: {
      borderRadius: 2, // ExpansionPanel border-bottom-radius
    },
    expansionPanel: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
    },
    expansionPanelContent: {
      width: '100%',
    },
  });
};

const enhance = compose<OptionDesktopProps, OwnProps>(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
);

export const OptionDesktop = enhance(OptionDesktopBase);

OptionDesktop.displayName = 'OptionDesktop';
